import { Immutable } from "immer";
import React from "react";

import { useAppSelector } from "../../../store/reducers";
import {
    PredictedDeliveryDateStatus,
    PreferredDeliveryDateDisplayType,
} from "../constants";

import styles from "./index.module.scss";

export const PreferredDeliveryDateHelpText = (
    props: Immutable<{
        type: PreferredDeliveryDateDisplayType;
    }>,
): React.ReactNode => {
    const prediction = useAppSelector(
        (rootState) => rootState.checkout.data.predicted_delivery_date,
    );

    if (props.type === PreferredDeliveryDateDisplayType.DISABLED) {
        return null;
    }
    if (!prediction) {
        return null;
    }
    // Hide this help text when the user's location is "unpredictable"
    // I.e. Convey zones 3 or higher, or when the convey API is down.
    if (
        prediction.status === PredictedDeliveryDateStatus.ERROR &&
        (prediction.data.status_code === "unpredictable-location-error" ||
            prediction.data.status_code === "deliverydates-api-offline-error")
    ) {
        return null;
    }
    return (
        <div className={styles.root}>
            <em>
                {/* TODO(i18n): Use t tagged template: {t`You can select your preferred delivery date during checkout.`} */}
                You can select your preferred delivery date during checkout.
            </em>
        </div>
    );
};
